import { useAction, useAtom } from '@reatom/npm-react'
import { useRef } from 'react'
import styled from 'styled-components'

import { TradingAudit } from '@root/entities/pair/ui/common'
import { skipShowAuditAction } from '@root/features/trade/trading'
import { DtDrawer, type DrawerControlProps } from '@root/shared/ui-kit'

import { tradeMakerFilterAtom } from '../../atoms/reatom-trades-table'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps &
  DrawerControlProps

export const TradeAuditDrawer: React.FC<Props> = ({
  className,
  open,
  onOpenChange,
  pair,
}) => {
  const skipShowAudit = useAction(skipShowAuditAction)
  const [makerFilter] = useAtom(tradeMakerFilterAtom)
  const scrollRef = useRef<HTMLDivElement>(null)

  return (
    <Root
      className={className}
      open={open}
      onOpenChange={onOpenChange}
      contentRef={scrollRef}
    >
      <TradingAudit
        onProceed={() => onOpenChange?.(false)}
        onNeverShowAgain={() => {
          skipShowAudit()
          onOpenChange?.(false)
        }}
        pair={pair}
        makerFilter={makerFilter}
      />
    </Root>
  )
}

const Root = styled(DtDrawer)`
  background: var(--background-1);
`
